import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rootReducer from 'store/root.reducer'
import rootSaga from 'store/root.saga'

const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose

const sagaMiddleware = createSagaMiddleware()
const history = createBrowserHistory()
const middlewares = [routerMiddleware(history), sagaMiddleware]

export { history }

export const store = createStore(
  rootReducer(history),
  composeEnhancers(applyMiddleware(...middlewares)),
)

sagaMiddleware.run(rootSaga)
